export default __webpack_public_path__ + "static/bannerPubli-ce0bdc937869ddb3f6de3f26f3c0454f.png";